import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import cardsService from './cardsService';

// cards updating

const initialState = {
  headingCard: {
    updatedHeadingState: '', // status and message coming here for heading card
    headingCardError: false,
    headingCardSuccess: false,
    headingCardLoading: false,
    headingCardErrorMsg: '',
  },
  linkCard: {
    updatedLinkCard: '', // status and message coming here for link card
    linkCardError: false,
    linkCardSuccess: false,
    linkCardLoading: false,
    linkCardErrorMsg: '',
  },
  avatarCard: {
    updatedavatarCard: '', // status and message coming here for avatar card
    avatarCardError: false,
    avatarCardSuccess: false,
    avatarLoading: false,
    avatarCardErrorMsg: '',
  },
  socialCard: {
    updatedSocialCard: '', // status and message coming here for avatar card
    socialCardError: false,
    socialCardSuccess: false,
    socialCardLoading: false,
    socialCardErrorMsg: '',
  },
  youtubeCard: {
    updatedYoutubeCard: '',
    updatedYoutubeCardError: false,
    updatedYoutubeCardSuccess: false,
    updatedYoutubeCardLoading: false,
    updatedYoutubeCardErrMsg: '',
  },
  faqCard: {
    updatedFaqCard: '',
    updatedFaqCardError: false,
    updatedFaqCardSuccess: false,
    updatedFaqCardLoading: false,
    updatedFaqCardErrMsg: '',
  },
};

// updating heading
export const updatingHeading = createAsyncThunk(
  'heading/updatingHeading',

  async (data, thunkAPI) => {
    try {
      const response = await cardsService.updatingHeading(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// updating linkCard fields
export const updatingLinkCard = createAsyncThunk(
  'link/updatingHeading',

  async (data, thunkAPI) => {
    try {
      const response = await cardsService.updatingLinkCard(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// updating avatarCard fields
export const updatingAvatarCard = createAsyncThunk(
  'avatar/updatingAvatarCard',

  async (data, thunkAPI) => {
    try {
      const response = await cardsService.updatingAvatarCard(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// updating socialCard fields
export const updatingSocialCard = createAsyncThunk(
  'socialcard/updatingSocialCard',

  async (data, thunkAPI) => {
    try {
      const response = await cardsService.updatingSocialCard(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

// updating Youtube card
export const updatingYoutubeCard = createAsyncThunk(
  'youtube/updatingYouTubeCard',

  async (data, thunkAPI) => {
    try {
      const response = await cardsService.updatingYoutubeCard(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const updatingFaqCard = createAsyncThunk(
  'faq/updatingFaqCard',

  async (data, thunkAPI) => {
    try {
      const response = await cardsService.updatingFaqCard(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response && error.response.data && error.response.data.errorMsg) || error.errorMsg || error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const cardSlice = createSlice({
  // handle the api response(promise coming from api) , either
  name: 'card',
  initialState,
  reducers: {
    // heading card
    resetCardHeading: (state) => {
      state.headingCard.headingCardError = false;
      state.headingCard.headingCardSuccess = false;
      state.headingCard.headingCardLoading = false;
      state.headingCard.headingCardErrorMsg = '';
    },

    // link card
    resetCardLink: (state) => {
      state.linkCard.linkCardError = false;
      state.linkCard.linkCardSuccess = false;
      state.linkCard.linkCardLoading = false;
      state.linkCard.linkCardErrorMsg = '';
    },
    // avatar card
    resetAvatarCard: (state) => {
      state.avatarCard.avatarCardError = false;
      state.avatarCard.avatarCardSuccess = false;
      state.avatarCard.avatarLoading = false;
      state.avatarCard.avatarCardErrorMsg = '';
    },
    // social card card
    resetSocialCard: (state) => {
      state.Card.socialCardError = false;
      state.socialCard.socialCardSuccess = false;
      state.socialCard.socialCardLoading = false;
      state.socialCard.socialCardErrorMsg = '';
    },

    // reset youtube card
    resetYoutubeCard: (state) => {
      state.youtubeCard.updatedYoutubeCardError = false;
      state.youtubeCard.updatedYoutubeCardSuccess = false;
      state.youtubeCard.updatedYoutubeCardLoading = false;
      state.youtubeCard.updatedYoutubeCardErrMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      // ________________________heading card ___________________
      .addCase(updatingHeading.pending, (state) => {
        state.headingCard.headingCardLoading = true;
      })
      .addCase(updatingHeading.fulfilled, (state, action) => {
        state.headingCard.headingCardLoading = false;
        state.headingCard.headingCardSuccess = true;
        state.headingCard.updatedHeadingState = action.payload;
      })
      .addCase(updatingHeading.rejected, (state, action) => {
        state.headingCard.headingCardLoading = false;
        state.headingCard.headingCardError = true;
        state.headingCard.headingCardErrorMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      })

      // link card
      .addCase(updatingLinkCard.pending, (state) => {
        state.linkCard.linkCardLoading = true;
      })
      .addCase(updatingLinkCard.fulfilled, (state, action) => {
        state.linkCard.linkCardLoading = false;
        state.linkCard.linkCardSuccess = true;
        state.linkCard.updatedLinkCard = action.payload;
      })
      .addCase(updatingLinkCard.rejected, (state, action) => {
        state.linkCard.linkCardLoading = false;
        state.linkCard.linkCardError = true;
        state.linkCard.linkCardErrorMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      })

      // updating avtar card
      .addCase(updatingAvatarCard.pending, (state) => {
        state.avatarCard.avatarLoading = true;
      })
      .addCase(updatingAvatarCard.fulfilled, (state, action) => {
        state.avatarCard.avatarLoading = false;
        state.avatarCard.avatarCardSuccess = true;
        state.avatarCard.updatedavatarCard = action.payload;
      })
      .addCase(updatingAvatarCard.rejected, (state, action) => {
        state.avatarCard.avatarLoading = false;
        state.avatarCard.avatarCardError = true;
        state.avatarCard.avatarCardErrorMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      })

      // updating  social card
      .addCase(updatingSocialCard.pending, (state) => {
        state.socialCard.socialCardLoading = true;
      })
      .addCase(updatingSocialCard.fulfilled, (state, action) => {
        state.socialCard.socialCardLoading = false;
        state.socialCard.socialCardSuccess = true;
        state.socialCard.updatedSocialCard = action.payload;
      })
      .addCase(updatingSocialCard.rejected, (state, action) => {
        state.socialCard.socialCardLoading = false;
        state.socialCard.socialCardError = true;
        state.socialCard.socialCardErrorMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      })

      // updating  youtube card
      .addCase(updatingYoutubeCard.pending, (state) => {
        state.youtubeCard.updatedYoutubeCardLoading = true;
      })
      .addCase(updatingYoutubeCard.fulfilled, (state, action) => {
        state.youtubeCard.updatedYoutubeCardLoading = false;
        state.youtubeCard.updatedYoutubeCardSuccess = true;
        state.youtubeCard.updatedYoutubeCard = action.payload;
      })
      .addCase(updatingYoutubeCard.rejected, (state, action) => {
        state.youtubeCard.updatedYoutubeCardLoading = false;
        state.youtubeCard.updatedYoutubeCardError = true;
        state.youtubeCard.updatedYoutubeCardErrMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      })
      .addCase(updatingFaqCard.pending, (state) => {
        state.youtubeCard.updatedFaqCardLoading = true;
      })
      .addCase(updatingFaqCard.fulfilled, (state, action) => {
        state.youtubeCard.updatedFaqCardLoading = false;
        state.youtubeCard.updatedFaqCardSuccess = true;
        state.youtubeCard.updatedFaqCard = action.payload;
      })
      .addCase(updatingFaqCard.rejected, (state, action) => {
        state.youtubeCard.updatedFaqCardLoading = false;
        state.youtubeCard.updatedFaqCardError = true;
        state.youtubeCard.updatedFaqCardErrMsg = action.payload; // error from catch will come here via action.payload and update errorMsg
      });
  },
});

export const {
  resetCardHeading,
  resetCardLink,
  resetAvatarCard,
  resetSocialCard,
  resetYoutubeCard,
  // resetTwitterCard,
  // resetInstagramCard,
} = cardSlice.actions;
export default cardSlice.reducer;
